/**
 * Shared `FileDropZone` (LF-4642) — public surface.
 */

export { FileDropZone } from './file-drop-zone';
export { FileDropZoneList } from './file-drop-zone-list';
export { FileDropZoneItem } from './file-drop-zone-item';
export { FileRow } from './file-row';
export type { FileRowProps, FileRowStatus } from './file-row';
export { useFileDropZoneState } from './use-file-drop-zone-state';
export type { FileDropZoneUploadContext } from './use-file-drop-zone-state';
export {
  matchesFileAccept,
  validateFileAccept,
  resolveUploadMimeType
} from './validate-file';
export type { FileAcceptConstraint } from './validate-file';
export { FILE_DROP_ZONE_DRAG_COPY } from './file-drop-zone-surface';
export { StrayFileDropGuard } from './stray-file-drop-guard';
export { DEFAULT_BANNER_SELL, DEFAULT_COMPACT_SELL, resolveSell } from './sell';
export { FILE_DROP_ZONE_ACCEPT } from './accept-presets';
export type { FileAcceptPreset } from './accept-presets';
export type {
  FileDropZoneProps,
  FileDropZoneVariant,
  SellConfig,
  SellProp,
  UploadFile
} from './types';
